import React from 'react';

import EmptyState from '@components/Gui/EmptyState';

import { UploadsGridLayout } from '@containers/Art/Uploads/UploadsGrid.styles';
import UploadsGridTile from '@containers/Art/Uploads/UploadsGridTile';

const UploadsGrid = ({ emptyMessage = 'No uploads found', uploads = [], onSelectUpload }) => {
    if (!uploads.length) {
        return <EmptyState message={emptyMessage} />;
    }

    return (
        <UploadsGridLayout>
            {uploads.map((upload) => (
                <UploadsGridTile key={upload.ID} upload={upload} onClick={onSelectUpload} />
            ))}
        </UploadsGridLayout>
    );
};

export default UploadsGrid;
